import Project1 from "../../assets/project1.webp";
import Project2 from "../../assets/project2.webp";
import Project3 from "../../assets/project3.webp";


export const projectsData = [
    {
        id: 1,
        image: Project1,
        title: "Project 1",
        category: "A",
    },
    {
        id: 2,
        image: Project2,
        title: "Project 2",
        category: "B",
    },
    {
        id: 3,
        image: Project3,
        title: "Project 3",
        category: "C",
    },
];

export const projectsNav = [
    {
        name: "All",
    },
    {
        name: "A",
    },
    {
        name: "B",
    },
    {
        name: "C",
    },
];